<script>
  import { HsvPicker } from "svelte-color-picker";
  import { clickOutside } from "./../utils/clickOutside.js";

  export let label;
  export let startColor;
  export let pickedColor;
  export let pickerOpen = false;

  function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  function colorCallback(rgba) {
    pickedColor = rgbToHex(rgba.detail.r, rgba.detail.g, rgba.detail.b);
    startColor = pickedColor;
  }

  function clickOutsideDropdown() {
    pickerOpen = false;
  }
</script>

<div class="select-row">
  <div class="label">{label}</div>
  <div
    class="colsquare"
    style={`background-color: ${startColor};`}
    on:click={() => {
      pickerOpen = true;
    }}
  />
  <div
    class={"picker-container"}
    use:clickOutside
    on:click_outside={clickOutsideDropdown}
  >
    {#if pickerOpen}
      <HsvPicker on:colorChange={colorCallback} {startColor} />
    {/if}
  </div>
</div>

<style>
  .picker-container {
    width: 240px;
    position: relative;
    bottom: 270px;
    left: 30px;
  }
  .select-row {
    margin-bottom: 4px;
  }
  .label {
    width: 100px;
    line-height: 1.5;
    float: left;
  }
  .colsquare {
    display: inline;
    float: left;
    width: 16px;
    height: 16px;
    border-radius: 2px;
  }
</style>
